import LandingReveal from '@/modules/Pages/shared/LandingReveal';

type HonestStatusSectionProps = {
  onWaitlistClick: () => void;
};

export default function HonestStatusSection({ onWaitlistClick }: HonestStatusSectionProps) {
  return (
    <section id="waitlist" className="py-24 px-6 bg-dark-gray-b border-t border-light scroll-mt-24">
      <div className="max-w-4xl mx-auto">
        <LandingReveal>
          <div
            className="landing-card relative overflow-hidden p-8 md:p-12 border-orange/25"
            style={{
              background:
                'linear-gradient(165deg, rgba(255, 190, 0, 0.06) 0%, rgba(14, 28, 42, 0.15) 45%, rgba(0, 185, 255, 0.05) 100%)',
            }}
          >
            <div
              className="pointer-events-none absolute -top-24 -right-16 h-56 w-56 rounded-full opacity-45 blur-3xl"
              style={{ background: 'rgba(255, 190, 0, 0.18)' }}
              aria-hidden
            />
            <div
              className="pointer-events-none absolute -bottom-28 left-1/3 h-72 w-72 rounded-full opacity-40 blur-3xl"
              style={{ background: 'rgba(0, 185, 255, 0.14)' }}
              aria-hidden
            />

            <div className="relative max-w-2xl mx-auto text-center">
              <p className="landing-section-label mb-4 text-accent">Where we stand</p>
              <h2 className="landing-headline text-2xl md:text-3xl font-bold leading-tight mb-6">
                That&apos;s the goal. Here&apos;s where we honestly stand.
              </h2>
              <div className="space-y-5 landing-prose">
                <p>We built the first version of ChurnSignal and tested it with an early customer.</p>
                <p>
                  There wasn&apos;t enough account volume or behavioral diversity to put the model under a proper test.
                </p>
                <p className="text-primary font-medium">
                  We&apos;re opening ChurnSignal to more B2B SaaS teams so we can test it across larger, more varied
                  customer bases and see what actually holds up.
                </p>
              </div>

              <div
                className="mx-auto my-10 h-[3px] w-16 rounded-full"
                style={{
                  background: 'linear-gradient(90deg, #ffbe00 0%, #00b9ff 100%)',
                  boxShadow: '0 0 12px rgba(0, 185, 255, 0.45), 0 0 18px rgba(255, 190, 0, 0.25)',
                }}
                aria-hidden
              />

              <h3 className="landing-headline text-xl md:text-2xl font-bold leading-tight mb-4">
                Get early access to ChurnSignal.
              </h3>
              <p className="landing-prose mb-7">
                We&apos;re opening access gradually to teams with enough customer activity to properly test ChurnSignal in
                the real world. Join the waitlist and tell us a little about your customer base and how you manage churn
                risk today.
              </p>
              <button
                type="button"
                onClick={onWaitlistClick}
                className="inline-flex px-8 py-4 rounded-lg font-semibold transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]"
                style={{
                  backgroundColor: '#fafafa',
                  color: '#0e1c2a',
                  boxShadow: '0 8px 32px rgba(250, 250, 250, 0.1)',
                }}
              >
                Join the waitlist
              </button>
            </div>
          </div>
        </LandingReveal>
      </div>
    </section>
  );
}
